module.exports = __webpack_public_path__ + "static/media/signup.49ab1407.svg";